import { render, staticRenderFns } from "./DataTable2.vue?vue&type=template&id=aa9d382a&scoped=true"
import script from "./DataTable2.vue?vue&type=script&lang=ts"
export * from "./DataTable2.vue?vue&type=script&lang=ts"
import style0 from "./DataTable2.vue?vue&type=style&index=0&id=aa9d382a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9d382a",
  null
  
)

export default component.exports